module.exports = __webpack_public_path__ + "img/TIMES.157b6bda.svg";